// Helper function to return current activePackage
const getActivePackage = (numPressReleasesSelected, packages = []) => {
  // Initialize array with minimum_quantities
  const minimumQuantities = [];
  packages.map((pkg) => minimumQuantities.push(pkg.minimum_quantity));
  // If numPressReleasesSelected is in array, return that package
  if (minimumQuantities.includes(numPressReleasesSelected)) {
    const activePkg = packages.find((pkg) => {
      return pkg.minimum_quantity === numPressReleasesSelected;
    });
    return activePkg.pk;
  }
  // If numPressReleases is not in array, return package with greatest minimum_quantity
  // less than current numPressReleases
  minimumQuantities.push(numPressReleasesSelected);
  minimumQuantities.sort((a, b) => a - b);
  const activePkg = packages.find((pkg) => {
    return pkg.minimum_quantity === minimumQuantities[minimumQuantities
      .indexOf(numPressReleasesSelected) - 1];
  });
  // Returning 0 here results in no active package being selected and no corresponding discount
  if (activePkg === undefined) {
    return 0;
  }
  return activePkg.pk;
};

export default getActivePackage;
